// extracted by mini-css-extract-plugin
export default {"container":"_3y8c1","innerContainer":"_1oUTg","title":"_1iv7a","body":"_2B18O","list":"_17g2X","button":"_3wT9k","isMuted":"_1opDT"};